import { ref } from 'vue';
import { defineStore } from 'pinia';
import type { IMetricAdjustmentsFront } from '@/modules/settings/interfaces/MetricAdjustments';
import type { Iitems } from '@/modules/shared/interfaces/inputMultiple';

export const useMetricAdjustmentsStore = defineStore('excludeEmails', () => {
    const excludeEmails = ref<IMetricAdjustmentsFront[]>([]);
    const internalDomains = ref<Iitems[]>([]);
    const whitelisted = ref<string[]>([]);

    return {
        // properties
        excludeEmails,
        internalDomains,
        whitelisted,

        // Actions
        setExcludeEmails(newExcludeEmails: IMetricAdjustmentsFront[]) {
            excludeEmails.value = newExcludeEmails;
        },
        setInternalDomains(newInternalDomains: Iitems[]) {
            internalDomains.value = newInternalDomains;
        },
        setWhitelisted(newWhitelisted: string[]) {
            whitelisted.value = newWhitelisted;
        }
    };
});
